import React from "react";
import Button from "@mui/material/Button";
import { ReplayOutlined } from "@mui/icons-material";

function MultiSelectButtons(props) {
  const { selectedRowsCount, selectedRowsData, handleConfirmModal } = props;

  if (selectedRowsCount === 0) return null;

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        padding: "6px 12px",
        gap: "12px",
        width: "fit-content",
      }}
    >
      <Button
        variant="outlined"
        size="small"
        sx={{
          borderColor: "#d1d1d1",
          borderRadius: "12px",
          color: "#6e6e6e",
          fontWeight: 500,
          padding: "0 8px !important",
        }}
      >
        {selectedRowsCount} Selected
      </Button>

      <Button
        onClick={() => handleConfirmModal(selectedRowsData, "retry")}
        variant="text"
        size="small"
        sx={{
          color: "#6e6e6e",
          textTransform: "none",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: "4px",
          "&:hover": {
            backgroundColor: "#F1F6E3",
          },
          "&:active": {
            backgroundColor: "#F1F6E3",
          },
        }}
      >
        <ReplayOutlined fontSize="small" />
        Resend
      </Button>
    </div>
  );
}

export default MultiSelectButtons;
